import HerosectionHeader from "../../Componet/Herosection/HerosectionHeader";
import { CityCoverage } from "../../store/Utility/CityCoverage";
import { Container, Row, Col } from "reactstrap";
import { Helmet } from 'react-helmet-async';
import Error404 from "../Utilities/Error404";
import { Link } from "react-router-dom";

const PrePurchaseInspection = ({ city }) => {

    const cityResult = CityCoverage.find(t => t.cityUrl == city);

    if (!cityResult) {
        return <Error404 />
    }

    return (<>
        <Helmet>
            <title>{cityResult.title}</title>
            <meta name="keywords" content={cityResult.keywords} />
            <meta name="description" content={cityResult.description} />
            <link rel="canonical" href={"/pre-purchase-inspection-" + cityResult.cityUrl} />
        </Helmet>

        <HerosectionHeader folder1={"Pages"} folder2={"Contacts"} name={cityResult.header} />
        <div className="page-content">
            <section>
                <Container>
                    <Row>
                        <div dangerouslySetInnerHTML={{ __html: cityResult.content }}>
                        </div>
                        <div> <p className="lead mb-3">
                            <strong> Starting from <mark><b>$139.00</b></mark></strong>
                        </p></div>
                    </Row>
                    <Row>
                        <Col md={2}>
                            <div style={{ padding: "0.7rem 0rem" }}>
                                <Link to="/sample-reports" className="text-decoration-underline" >View Sample Report</Link>
                            </div>

                        </Col>
                        <Col md={4}>
                            <div>
                                <Link className="btn btn-dark " to="/quotation">Order Your Inspection</Link>
                            </div>
                        </Col>

                    </Row>

                </Container>
            </section>

        </div>

    </>)
}

export default PrePurchaseInspection;